import { connect } from 'react-redux';
import * as BoardAction from './BoardAction';
import simpleDotProp from '../simpleDotProp';

const PostInfoInjector =
  (stateToProps = null, dispatchToProps = null) =>
  (WrapperComponent) => {
    const mapStateToProps = (state, ownProps) => {
      let props = {};
      if (stateToProps !== null) {
        props = stateToProps(state, ownProps);
      }
      const postInfo = ownProps.postInfo
        ? ownProps.postInfo
        : simpleDotProp.deepCopy(state.BoardReducer.postInfo);
      return {
        files: simpleDotProp.deepCopy(state.BoardReducer.files),
        postInfo: postInfo,
        ...props,
      };
    };

    const mapDispatchToProps = (dispatch, ownProps) => {
      const { boardType, boardName } = ownProps;
      let props = {};
      if (dispatchToProps !== null) {
        props = dispatchToProps(dispatch, ownProps);
      }
      return {
        getFiles: (postId) => {
          dispatch(BoardAction.getFileList(postId));
        },
        removePost: (postId) => {
          dispatch(BoardAction.removePost(boardType, boardName, postId));
        },
        clearPostData: () => {
          dispatch(BoardAction.clearPostData());
        },
        completedAction: () => {
          dispatch(BoardAction.completedAction());
        },
        ...props,
      };
    };
    return connect(mapStateToProps, mapDispatchToProps)(WrapperComponent);
  };

export default PostInfoInjector;
